exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mweb-vedio-height video{-o-object-fit:fill!important;object-fit:fill!important}@media screen and (max-width:768px){.mweb-vedio-height{height:50vw!important}}", "", {"version":3,"sources":["/app/src/components/listing.vue"],"names":[],"mappings":"AACA,yBACI,6BAA+B,AAC5B,yBAA4B,CAClC,AACD,oCACA,mBACM,qBAAmC,CACxC,CACA","file":"listing.vue","sourcesContent":["\n.mweb-vedio-height video {\n    -o-object-fit: fill !important;\n       object-fit: fill !important;\n}\n@media screen and (max-width: 768px) {\n.mweb-vedio-height {\n      height: calc(100vw / 2) !important;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6cee8452","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=5!./src/components/listing.vue
// module id = 2067
// module chunks = 15